import { CaretDownIcon, CaretUpIcon } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React, { CSSProperties } from 'react'

interface Props {
  displayedCount?: number
  expanded: boolean
  label: string
  onClick?: () => void
  selected: boolean
  style?: CSSProperties
}

export const DropdownButton = ({ displayedCount = 0, label, selected, onClick, expanded, style = {} }: Props) => {
  return (
    <button
      className={clsx(
        'flex h-10 flex-row items-center justify-between rounded-lg border px-4 border-secondary md:min-w-52',
        expanded ? 'bg-grey-100' : selected ? 'bg-action-input text-white' : 'bg-white',
      )}
      onClick={onClick}
      style={style}
    >
      <div className="flex flex-row items-center">
        <span className={clsx('text-sm', !displayedCount && 'mr-2')}>{label}</span>
        {!!displayedCount && (
          <div className="ml-2 flex h-5 w-5 items-center  justify-center rounded-full bg-action-primary text-white">
            <p className="text-center text-p-sm">{displayedCount}</p>
          </div>
        )}
      </div>
      {expanded ? <CaretUpIcon className="h-4 " /> : <CaretDownIcon className="h-4" />}
    </button>
  )
}
